// Debounce für serverseitige Autocomplete-Suchen (Titel-Vorschläge): der
// zurückgegebene Wert folgt `value` erst nach `delayMs` Tipp-Ruhe, damit
// nicht jeder Tastendruck eine API-Runde auslöst.
import { useEffect, useState } from 'react'

/** Standard-Verzögerung für Suggestion-Dropdowns. */
export const SEARCH_DEBOUNCE_MS = 200

/**
 * Pure Timer-Hälfte des Hooks: plant `fn` nach `delayMs` und gibt den
 * Cancel zurück. In React ist der Effect-Cleanup der Cancel bei jedem
 * neuen value — genau daraus entsteht das Debouncing (node-testbar ohne
 * Renderer, siehe use-debounced-value.test.ts).
 */
export function scheduleTrailing(fn: () => void, delayMs: number): () => void {
  const timer = setTimeout(fn, delayMs)
  return () => clearTimeout(timer)
}

export function useDebouncedValue<T>(value: T, delayMs = SEARCH_DEBOUNCE_MS): T {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => scheduleTrailing(() => setDebounced(value), delayMs), [value, delayMs])
  return debounced
}
